import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {LabelsRequestsService} from "../../services/labels-requests.service";

export class labelMultipleSelectCtrl implements IController {

  name:string;
  selectedLabelNames: any;
  options: any;
  parentValue: any;
  ngPlaceholder: any;
  noUnderline: Function;
  isRequired: boolean;
  onLabelsChange: Function;

  private excludeLabelNames: any;

  /* @ngInject */
  constructor(private $mdSelect, private labelsRequestsService: LabelsRequestsService, private $log) {
  }

  $onInit() {

    if (!this.name) {
      this.name = 'labels'
    }

    if (!this.excludeLabelNames) {
      this.excludeLabelNames = [];
    }
    if (!this.options) {
      this.labelsRequestsService.getAll()
        .then((labels) => {
          this.options = _.orderBy(labels, ['name'], ['asc']);
        })
        .catch((error) => {
          this.$log.error('Failed to get labels', error);
        })
    }
  };

  //////////////////////////////////////////////////////////////////////////

  doneHideSelect() {
    this.$mdSelect.hide();
  }

  resetHideSelect() {
    this.$mdSelect.hide();
    this.selectedLabelNames = [];
    this.onLabelsChange({labels: []});
  }
}

angular
  .module('bringoz.admin.labels')
  .component('labelMultipleSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      name: '@?',
      selectedLabelNames: '<',
      options: '<?',
      parentValue: '<?',
      ngPlaceholder: '@?',
      noUnderline: '@?',
      isRequired: '<?',
      onLabelsChange: '&'
    },
    template: require('./label-multiple-select.html').default,
    controller: labelMultipleSelectCtrl
  });
